import React, { FC, useMemo } from 'react'
import { PageProps } from 'gatsby'
import { changeLocale, useIntl } from 'gatsby-plugin-intl'

import withMemo from '../../decorators/withMemo'
import { Layout, Link } from '../../components'
import { HomepageTemplate } from '../../templates'
import { HeaderProps } from '../../components/Header'
import { useWindowSize } from '../../hooks/useWindowSize'
import { sizes } from '../../theme'

const HomepageContainer: FC<PageProps> = () => {
  const intl = useIntl()

  const windowSize = useWindowSize()

  const text = useMemo(() => {
    switch (intl.locale) {
      case 'en':
        return (
          <>
            <h2>Introduction</h2>
            <p>Balenciaga is committed to empower the imagination of all talents.</p>
            <p>
              Our mission as a brand and as a company is to promote creativity by supporting talents
              from everywhere and it is the reason why we want to collaborate with people from
              diverse locations, experiences, and backgrounds.
            </p>
            <p>
              This website is dedicated for creative talent applications. At this stage of our
              recruitment process, please note that Balenciaga does not accept any portfolio
              including personal work, but instead inspirational mood boards of existing and
              published works and material.
            </p>
          </>
        )
      case 'fr':
        return (
          <>
            <h2>Introduction</h2>
            <p>Balenciaga s’engage auprès des talents.</p>
            <p>
              Notre mission en tant que marque et entreprise est de promouvoir l’imagination, c’est
              pourquoi nous souhaitons collaborer avec des personnes d&apos;expériences et
              d&apos;horizons divers.
            </p>
            <p>
              Ce site est dédié aux candidatures de talents créatifs. À ce stade du processus de
              recrutement, Balenciaga n&apos;accepte aucun portfolio comprenant des travaux
              personnels, vous pouvez nous communiquer des mood boards d’inspiration d&apos;œuvres
              et de matériel existants et publiés.
            </p>
          </>
        )
      default:
        return null
    }
  }, [intl.locale])

  const text2 = useMemo(() => {
    switch (intl.locale) {
      case 'en':
        return (
          <p>
            You are interested in a career at Balenciaga outside of design:
            <br />
            look at our job adverts on{' '}
            <Link link={'https://kering.wd3.myworkdayjobs.com/Balenciaga'}>
              https://kering.wd3.myworkdayjobs.com/Balenciaga
            </Link>
          </p>
        )
      case 'fr':
        return (
          <p>
            Vous souhaitez nous rejoindre sur un poste hors design :
            <br />
            retrouvez nos autres offres d’emploi sur{' '}
            <Link link={'https://kering.wd3.myworkdayjobs.com/Balenciaga'}>
              https://kering.wd3.myworkdayjobs.com/Balenciaga
            </Link>
          </p>
        )
      default:
        return null
    }
  }, [intl.locale])

  const headerProps = useMemo<HeaderProps>(
    () => ({
      localeSelect: {
        options: [
          { label: windowSize.width > sizes.tablet ? 'Français' : 'FR', value: 'fr' },
          { label: windowSize.width > sizes.tablet ? 'English' : 'EN', value: 'en' },
        ],
        value: intl.locale,
        onChange: (value) => {
          changeLocale(value!.value)
        },
      },
    }),
    [intl.locale, windowSize.width]
  )

  return (
    <Layout>
      <HomepageTemplate
        headerProps={headerProps}
        title={intl.formatMessage({ id: 'title' })}
        text={text}
        text2={text2}
        button={{
          label: intl.formatMessage({ id: 'label' }),
          link: intl.formatMessage({ id: 'link' }),
        }}
      />
    </Layout>
  )
}

export default withMemo(HomepageContainer)
